module.exports = __webpack_public_path__ + "fonts/IBM_Plex_Sans-300-5.57bde7c.woff2";